<template>
  <div class="container">
    <Header
      :title="'Section 5: Healing and Recovery'"
      :details="
        'We are interested in hearing about your unique path to healing and recovery.'
      "
    />
    <div class="row">
      <div class="col">
        <label class="col-form-label">
          <strong
            >Did you tell anyone about the experience? If so, who did you
            tell?</strong
          >
        </label>
        <textarea
          class="form-control"
          rows="2"
          :value="values.tellWho"
          @keyup="e => handleValueChanged('tellWho', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">
          <strong
            >Have you experienced any notable response from sharing your
            experience with others?</strong
          >
          <br />
          <em
            >For example, hearing from other survivors for the first time,
            support from loved ones, alienation, or bullying</em
          >
        </label>
        <textarea
          class="form-control"
          rows="2"
          :value="values.reactionToSharing"
          @keyup="e => handleValueChanged('reactionToSharing', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <label class="col-form-label">
          <strong>Have you received counseling or any type of therapy?</strong>
        </label>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="counselingRadio"
              :checked="values.counselingRadio1"
              @change="
                e =>
                  handleValueChanged('counselingRadio1', e.target.checked, {
                    radio: 2
                  })
              "
            />
            Yes
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="counselingRadio"
              :checked="values.counselingRadio2"
              @change="
                e =>
                  handleValueChanged('counselingRadio2', e.target.checked, {
                    radio: 2
                  })
              "
            />
            No
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <label class="col-form-label"
          >If yes, what type of counseling have you received? (Check all that
          apply)</label
        >
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="counselingTypeRadio"
              :checked="values.counselingTypeRadio1"
              @change="
                e =>
                  handleValueChanged('counselingTypeRadio1', e.target.checked, {
                    radio: 3
                  })
              "
            />
            Individual
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="counselingTypeRadio"
              :checked="values.counselingTypeRadio2"
              @change="
                e =>
                  handleValueChanged('counselingTypeRadio2', e.target.checked, {
                    radio: 3
                  })
              "
            />
            Group
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="counselingTypeRadio"
              :checked="values.counselingTypeRadio3"
              @change="
                e =>
                  handleValueChanged('counselingTypeRadio3', e.target.checked, {
                    radio: 3
                  })
              "
            />
            Other
          </label>
        </div>
        <textarea
          class="form-control mt-2"
          rows="1"
          placeholder="Other"
          :value="values.counselingTypeOther"
          @keyup="
            e => handleValueChanged('counselingTypeOther', e.target.value)
          "
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">
          Where did you receive this support?
          <br />
          <em
            >For example, a therapist, a local sexual assault service provider,
            campus resource, church or faith-based institution etc</em
          >
        </label>
        <textarea
          class="form-control"
          rows="1"
          :value="values.counselingTypePlace"
          @keyup="
            e => handleValueChanged('counselingTypePlace', e.target.value)
          "
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">
          <strong
            >Have you experienced any psychological, physical, or emotional
            effects as a result of the assault or abuse?</strong
          >
          <br />
          <em>For example, eating disorders, depression or PTSD</em>
        </label>
        <textarea
          class="form-control"
          rows="2"
          :value="values.effects"
          @keyup="e => handleValueChanged('effects', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">
          <strong
            >Has the assault or abuse impacted your relationships with loved
            ones?</strong
          >
        </label>
        <textarea
          class="form-control"
          rows="2"
          :value="values.relationshipEffects"
          @keyup="
            e => handleValueChanged('relationshipEffects', e.target.value)
          "
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">
          <strong
            >Has anyone been especially helpful with your healing or criminal
            justice process?</strong
          >
          <br />
          <em
            >For example, a friend, family member, SANE nurse, police officer,
            counselor, etc.</em
          >
        </label>
        <textarea
          class="form-control"
          rows="2"
          :value="values.bestHelp"
          @keyup="e => handleValueChanged('bestHelp', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-value">
          <strong
            >Please feel free to add anything else you would like us to know
            about you or your experience.</strong
          >
        </label>
        <textarea
          class="form-control"
          rows="3"
          :value="values.additionalDetails"
          @keyup="e => handleValueChanged('additionalDetails', e.target.value)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Application/SectionHeader";
import { SectionFive } from "@/typings/application";

export default {
  name: "sectionFive",
  components: {
    Header
  },
  props: {
    values: {
      type: SectionFive,
      required: true,
      default: () => {
        return new SectionFive();
      }
    },
    onValueChanged: {
      type: Function,
      requried: true,
      default: () => {}
    }
  },
  methods: {
    handleValueChanged(name, value, details) {
      this.onValueChanged("section5", name, value);
      if (name === "counselingTypeOther") {
        this.handleValueChanged("counselingTypeRadio3", value.length > 0, {
          radio: 3
        });
      }
      if (details && details.radio) {
        // Ensures that only one radio within a radio group is selected at a
        // time.
        const radio = name.split("Radio");
        const index = parseInt(radio[1]);
        for (let i = 1; i <= details.radio; i++) {
          if (index !== i) {
            this.onValueChanged("section5", `${radio[0]}Radio${i}`, false);
          }
        }
      }
    }
  }
};
</script>

<style></style>
